import { useQueries } from 'react-query';
import CompanyService from 'App/services/CompanyService';
import { useUserContext } from 'App/contexts/UserContext';
import { patientRecordTabs } from 'App/components/PatientProfile/components/PatientRecordModal/PatientRecord/patientRecordTabs';

function usePatientRecordSections() {
    const user = useUserContext();
    const branchId = user?.active_branch?.ID;

    const results = useQueries(
        patientRecordTabs.map((tab) => ({
            queryKey: ['company', user?.active_company?.ID, 'branch', branchId, 'settings', tab.settingKey],
            cacheTime: 1000 * 60 * 5,
            queryFn: () => CompanyService.getBranchSettings(tab.settingKey, false, true, branchId),
        }))
    );

    const isLoading = results.some((result) => result.isLoading);

    const tabs = patientRecordTabs.filter((_, index) => results[index].data === true);

    return { tabs, isLoading };
}

export default usePatientRecordSections;
